import { StateField } from '@codemirror/state';
import { Decoration, EditorView } from '@codemirror/view';

const VARIABLES_REGEXP = /\$.*?;/g;

const createDecorations = (doc) => {
  const decorations = [];
  const text = doc.toString();

  let match = VARIABLES_REGEXP.exec(text);

  while (match) {
    const start = match.index;
    const end = start + match[0].length;
    const range = Decoration.mark({ class: 'variable-tag' }).range(start, end);

    decorations.push(range);

    match = VARIABLES_REGEXP.exec(text);
  }

  return Decoration.set(decorations);
};

export const variableStyles = EditorView.baseTheme({
  '.variable-tag span': {
    color: 'var(--color-blue-300) !important'
  },
  '.variable-tag': {
    backgroundColor: '#006cb730',
    borderRadius: '20px',
    color: 'var(--color-blue-300) !important',
    padding: '1px 4px 3px'
  },
  '.cm-line .variable-tag::selection': {
    backgroundColor: 'rgba(0,0,0,.15) !important',
    borderRadius: 'var(--border-radius-base)'
  }
});

export const variableHighlighting = StateField.define({
  create(state) {
    return createDecorations(state.doc);
  },
  update(decorations, tr) {
    if (tr.docChanged) {
      return createDecorations(tr.newDoc);
    }

    return decorations;
  },
  provide: (f) => EditorView.decorations.from(f)
});
